<H1>Analyser</H1>


Warning Analyser is not tested on a live system. It should be done before using this.
There is a new version of the analyser component.


<mat-card class="analyser-card">

  <mat-card-header>
    <div mat-card-avatar class="analyser-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">av_timer</mat-icon>
    </div>

    <mat-card-title> Analyser </mat-card-title>

    <mat-card-subtitle> Needs to have analyser linkup  </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-grid-list cols="5" rowHeight="100px">
      <mat-grid-tile style="background: thistle" colspan="3" rowspan="1">
        <h2>{{ analyser.LCD_LINE_0 }}</h2>
      </mat-grid-tile>
      <mat-grid-tile style="background: cornsilk" colspan="1" rowspan="1">
        <button mat-icon-button aria-label="Up" (click)="OnUp()">
          <mat-icon>arrow_circle_up</mat-icon>
        </button>
      </mat-grid-tile>
      <mat-grid-tile style="background: cornsilk" colspan="1" rowspan="1">
        <button mat-icon-button aria-label="Graph" (click)="OnGraph()">
          <mat-icon>settings_backup_restore</mat-icon>
        </button>
      </mat-grid-tile>
      <mat-grid-tile style="background: cornflowerblue" colspan="3" rowspan="1">
        <h2>{{ analyser.LCD_LINE_1 }}</h2>
      </mat-grid-tile>
      <mat-grid-tile style="background: cornsilk" colspan="1" rowspan="1">
        <button mat-icon-button aria-label="Down" (click)="OnDown()">
          <mat-icon>arrow_circle_down</mat-icon>
        </button>
      </mat-grid-tile>
      <mat-grid-tile style="background: cornsilk" colspan="1" rowspan="1">
        <button mat-icon-button aria-label="Enter" (click)="OnEnter()">
          <mat-icon>next_plan</mat-icon>
        </button>
      </mat-grid-tile>
    </mat-grid-list>


  </mat-card-content>

</mat-card>








